<template>
  <div class="bobinas-resumen">
    <div class="bobinas-resumen-item">
      <span class="bobinas-resumen-label">Ancho máx. máquina (mm)</span>
      <span class="bobinas-resumen-value">{{
        anchoMaximoMaquina ? formatNumberLocale(anchoMaximoMaquina, 2) : '—'
      }}</span>
    </div>
    <div class="bobinas-resumen-item">
      <span class="bobinas-resumen-label">Bobinas en el ancho</span>
      <span class="bobinas-resumen-value">{{ bobinasEnElAncho }}</span>
    </div>
    <div class="bobinas-resumen-item">
      <span class="bobinas-resumen-label">Ancho Extrusión (mm)</span>
      <span class="bobinas-resumen-value">{{ formatNumberLocale(anchoExtrusion, 2) }}</span>
    </div>
    <div class="bobinas-resumen-item">
      <span class="bobinas-resumen-label">Bobinas por bajada</span>
      <span class="bobinas-resumen-value">{{ bobinasPorBajada }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatNumberLocale } from '@/shared/utils/locale_number_utils.js';

const props = defineProps({
  bobinas: { type: Array, default: () => [] },
  factorMultiplicacion: { type: Number, default: 1 },
  // anchoMaximoMaquina:     { type: Number,  default: 0 },
  aprovecharAnchoMaximo: { type: Boolean, default: false },
  recurso: { type: Object, default: () => ({}) },
});

const anchoMaximoMaquina = computed(() => props.recurso?.AnchoMaximo ?? 0);

const sumAnchosBobinas = computed(() =>
  props.bobinas.reduce((sum, f) => sum + (Number(f.Ancho) || 0), 0),
);

const bobinasEnElAncho = computed(() => {
  if (props.aprovecharAnchoMaximo) {
    const ancho = props.bobinas[0]?.Ancho;
    if (ancho > 0 && props.recurso?.AnchoMaximo > 0) {
      return Math.floor(props.recurso.AnchoMaximo / ancho);
    }
    return 0;
  }
  return props.bobinas.length;
});

const anchoExtrusion = computed(() => {
  if (props.aprovecharAnchoMaximo) {
    return bobinasEnElAncho.value * sumAnchosBobinas.value;
  }
  return sumAnchosBobinas.value;
});

const bobinasPorBajada = computed(() => bobinasEnElAncho.value * props.factorMultiplicacion);
</script>

<style scoped>
.bobinas-resumen {
  display: flex;
  gap: 24px;
  padding: 10px 14px;
  background: #f5f7fa;
  border-radius: 6px;
  border: 1px solid #e4e7ed;
}

.bobinas-resumen-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.bobinas-resumen-label {
  font-size: 11px;
  color: #909399;
  margin-bottom: 2px;
}

.bobinas-resumen-value {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}
</style>
